import { type LandingContentsQuickAccessItemsInner } from '@clients/ContentApi';
import { toAbsoluteSrc } from '@store/content';

export class QuickAccess {
    id = 'quick-Access';
    Title = '';
    Link = '';
    Icon: { src: string; alt: string };
    Description?: string;
    Color = 'var(--blue-200)';
    constructor(data: LandingContentsQuickAccessItemsInner) {
        const { Color, Icon, ...rest } = data;
        Object.assign(this, rest);
        this.Icon = {
            src: toAbsoluteSrc(Icon.url),
            alt: Icon.alternativeText || '',
        };
        this.Color = `var(--${Color}-200)`;
    }

    toJSON() {
        return { ...this };
    }
}
